import React, { FormEvent, useCallback, useEffect, useMemo, useState } from 'react'
import { AiOutlinePlusSquare } from 'react-icons/ai'
import useApi from '../../hooks/useApi'
import { Diagnosis } from '../../types/Diagnosis'
import { Trail } from '../../types/Trail'
import { NameAndDescription } from './DiagnosisFiledpart/NameAndDescription'
import { QuestionFields } from './QuestionFields'

export const DiagnosisFields = ({ diagnosis }: Props) => {

    const api = useApi()

    const [countQuestion, setCountQuestion] = useState<number>(0)

    const [trails,setTrails] = useState<Trail[]>([])

    const handleNew = useCallback(async (e: FormEvent<HTMLFormElement>) => {

        if (!diagnosis) return

        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)

        await api.post(`/admin/diagnoses/${diagnosis.id}/new-question`, data).then(res => {
            window.location.reload()
        }).catch(console.log)

    }, [api, diagnosis])

    const handleUpdate = useCallback(async (e: FormEvent<HTMLFormElement>,id:string) => {
        if (!diagnosis) return
        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)
        data.append('_method', 'PATCH')
        return await api.post(`/admin/questions/${id}`, data).then(res => {
            window.location.reload()
        }).catch(console.log)


    }, [api, diagnosis])

    const loadTrails = useCallback( async ()=>{
        await api.get("/admin/trails").then(res => {
            setTrails(res.data);
        }).catch(console.log)
    },[setTrails,api])

    const renderQuestion = useMemo(() => {
        let questions = []
        for (let i = 0; i < countQuestion; i++) {
            questions.push(
                <QuestionFields trails={trails} key={`${i}q`} name={`${i + 1}`}
                    remove={(i + 1) === countQuestion ? () => setCountQuestion(prev => prev - 1) : undefined}
                    newQuestion={diagnosis && true}
                />

            )
        }
        return questions
    }, [countQuestion, diagnosis,trails])

    useEffect(()=>{
        loadTrails()
    },[loadTrails])

    return (
        <>
            <div className='rounded border border-gray-600 bg-white p-6 my-2 flex flex-col'>
                <NameAndDescription diagnosis={diagnosis && diagnosis} />
            </div>
            <>
                {diagnosis?.questions.map(item => (
                    <form key={item.id} onSubmit={(e)=>handleUpdate(e,item.id)}>
                        <QuestionFields trails={trails} name={item.id} question={item} />
                    </form>

                ))}
                {renderQuestion.map(item => (
                    <div key={item.key}>
                        {diagnosis &&
                            <form className='flex flex-col' onSubmit={handleNew}>{item} </form>}
                        {!diagnosis && item}
                    </div>
                ))}

            </>
            <button className='flex justify-center p-2 items-center border border-dotted 
                                 border-gray-600 text-md my-2'
                type={'button'} onClick={() => setCountQuestion(prev => prev + 1)}>
                <AiOutlinePlusSquare className='mr-2' /> Adicionar questão
            </button>
        </>

    )
}
interface Props {
    diagnosis?: Diagnosis
}